import normalizeCif from 'utils/normalizeCif';

import { getSocietySharesLedger } from 'modules/society/api/getSocietySharesLedger';

import { ConstitutionExistingPartner } from 'modules/_shared/components/Modals/Constitution/utils/fetchExistingPartnersForConstitution';

import { SharesTransferLedgerState } from '../types/SharesTransferExcel';

export const fetchInitialLedgerForExcel = async ({
  societyId,
  holdingClassId,
  existingPartners,
}: {
  societyId: string;
  holdingClassId: string;
  existingPartners: ConstitutionExistingPartner[];
}): Promise<SharesTransferLedgerState> => {
  const cifByPartnerId: Record<string, string> = {};

  existingPartners.forEach((partner) => {
    if (partner.cif) {
      cifByPartnerId[partner._id] = normalizeCif(partner.cif);
    }
  });

  const ledgerByPartnerId = await getSocietySharesLedger({
    societyId,
    holdingClassId,
  });

  const ledger: SharesTransferLedgerState = {};

  Object.entries(ledgerByPartnerId).forEach(([partnerId, ranges]) => {
    const cif = cifByPartnerId[partnerId];

    if (!cif) {
      return;
    }

    ledger[cif] = ranges.map((range) => ({
      from: range.from,
      to: range.to,
      shareClass: holdingClassId,
      encumbrances: range.encumbrances || [],
    }));
  });

  return ledger;
};
